import React, { useState, useEffect } from 'react';
import Container from 'olive-react-myoneui/lib/Container';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import CourseCurriculumTabs from './CourseCurriculumTabs';
import CourseCurriculumsHeader from './CourseDetailsHeader';
import AddToCartVerticalBlock from '../AddToCartVerticalBlock';
import CoursesList from './CoursesList';
import Helmet from 'react-helmet';

function CourseCurriculum({ coursedetails }) {

  const [totalLecturesCount, setTotalLecturesCount] = useState(coursedetails?.course.lecture_count);
  const [totalCoursesCount, setTotalCoursesCount] = useState(0);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    goToTop();
  }, []);

  return (
    <>
      <Helmet>
        <title>{coursedetails?.meta_original_title}</title>
        <meta
          name="title"
          content={coursedetails?.meta_title}
          data-react-helmet="true"
        ></meta>
        <meta
          name="description"
          content={coursedetails?.course.cb_meta_description}
        ></meta>

        <meta property="og:type" content="course" />
        <meta property="og:title" content={coursedetails?.meta_title} />
        <meta
          property="og:description"
          content={coursedetails?.course.cb_meta_description}
        />

        <meta name="twitter:creator" content="course" />
        <meta name="twitter:card" content="course" />
        <meta name="twitter:title" content={coursedetails?.meta_title} />
        <meta
          name="twitter:description"
          content={coursedetails?.course.cb_meta_description}
        />
      </Helmet>
      <div className='res-add-cart-block'>
        <AddToCartVerticalBlock coursedetails={coursedetails} totalLecturesCount={totalLecturesCount} totalCoursesCount={totalCoursesCount} />
      </div>
      <CourseCurriculumsHeader className="mb-4" coursedetails={coursedetails} />
      <Container>
        <Row>
          <Col lg={12}>
            <div className="course-inner-divison">
              <div className='res-add-cart-detail-block'>
                <AddToCartVerticalBlock coursedetails={coursedetails} totalLecturesCount={totalLecturesCount} totalCoursesCount={totalCoursesCount} />
              </div>
              <CourseCurriculumTabs coursedetails={coursedetails} />
              <div className='mobile-add-cart-block'>
                <AddToCartVerticalBlock coursedetails={coursedetails} totalLecturesCount={totalLecturesCount} totalCoursesCount={totalCoursesCount} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CourseCurriculum;
